// extracted by mini-css-extract-plugin
module.exports = {"image-card":"ImageCard_image-card__sG0n1","image-card__image":"ImageCard_image-card__image__sP1bd"};